import { render, staticRenderFns } from "./MailParserInfo.vue?vue&type=template&id=5b68d7dc&scoped=true&"
import script from "./MailParserInfo.vue?vue&type=script&lang=js&"
export * from "./MailParserInfo.vue?vue&type=script&lang=js&"
import style0 from "./MailParserInfo.vue?vue&type=style&index=0&id=5b68d7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68d7dc",
  null
  
)

export default component.exports